import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIconStyled } from './SvgIcon.styled';
const SvgIcon = ({ icon, size, color, transition, disabled, inheritViewBox, sx, ...props }) => {
    return (_jsx(SvgIconStyled
    // ...props are required
    , { ...props, component: icon, size: size, color: color, transition: transition, disabled: disabled, inheritViewBox: inheritViewBox ?? true, sx: sx }));
};
export { SvgIcon };
